module.exports = __webpack_public_path__ + "img/xrp-coin.2d36c52f.png";